/** Mask characters (whitespace, dot, hyphen) tolerated in a formatted identifier. */
export const SEPARATORS_REGEX = /[\s.-]/g;
